import {Component, OnDestroy, OnInit} from '@angular/core';
import {DashboardService} from './dashboard.service';
import {forkJoin, Subscription} from 'rxjs';
import {Constants} from 'src/app/shared/utils/constants';
import { TotalProfitData } from 'src/app/shared/components/total-profit/total-profit.component';
import { ProfitData } from './profit/profit.component';
import { DashboardDataRequest } from './models/dashboard-data-request.interface';
import { getTimeDateBegin } from 'src/app/shared/utils/helper';
import { DashboardSummary } from './models/dashboard-sumary.interface';

@Component({
  selector: 'fx-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.sass'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  dataSummary: TotalProfitData = {};
  data: any = {};
  laterData: any = {};
  dataWallet: any = {};
  dataLaterWallet: any = {};
  subscription: Subscription;
  timeInfo: any = {
    tf: 'day',
    from: null,
    to: null
  };
  currency = 'jpy';
  summaryWaiting = false;
  profitWaiting = false;
  walletWaiting = false;
  now = Date.now();
  datepickerFilter = (date: Date | null) => {
    return date.getTime() < this.now;
  }
  constructor(private service: DashboardService) {
    this.getSummary();
    this.getProfitDashboardHistory();
  }

  ngOnInit(): void {}

  getSummary(): void {
    this.summaryWaiting = false;
    this.subscription = this.service.getSummary()
      .subscribe(
        (data) => {
          if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
            const resData = data.data;
            this.dataSummary.customer = resData.trader_profit;
            this.dataSummary.commission = resData.trader_commission;
            this.dataSummary.swap = resData.trader_swap;
            this.dataSummary.profit = (this.dataSummary.customer + this.dataSummary.commission + this.dataSummary.swap);

            this.dataSummary.ib = resData.ib_reward;
            this.dataSummary.bonus = resData.trader_credit_bonus;
            this.dataSummary.wallet = resData.trader_withdrawl;
            this.dataSummary.feePayout = (this.dataSummary.ib + this.dataSummary.bonus + this.dataSummary.wallet);

            this.dataSummary.netProfit = (this.dataSummary.profit + this.dataSummary.feePayout);

            this.dataSummary.date = Date.now();
          }
        },
        () => void 0,
        () => {
          this.summaryWaiting = true
        }
      );
  }

  private getProfitDashboardHistory(): void {
    const params = this.getParams();
    const mappingData: ProfitData = {};
    const mappingLaterData: Record<string, number> = {};
    this.walletWaiting = false;
    this.profitWaiting = false;
    this.service.getData(params).subscribe(data => {
      if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
        const resData: ProfitData = data.data.reduce<ProfitData>((acc, cur: DashboardSummary) => {
          acc.bonus.push({
            value: cur.trader_credit_bonus,
            timestamp: 0,
            time_: cur.time_,
          });
          acc.commission.push({
            value: cur.trader_commission,
            timestamp: 0,
            time_: cur.time_,
          });
          acc.customer.push({
            value: cur.trader_profit,
            timestamp: 0,
            time_: cur.time_,
          });
          acc.ib.push({
            value: cur.ib_reward,
            timestamp: 0,
            time_: cur.time_,
          });
          acc.swap.push({
            value: cur.trader_swap,
            timestamp: 0,
            time_: cur.time_,
          });
          acc.total.push({
            value: cur.trader_profit + cur.trader_commission + cur.trader_swap + cur.ib_reward + cur.trader_credit_bonus,
            timestamp: 0,
            time_: cur.time_,
          })

          return acc;
        }, {
          bonus: [],
          commission: [],
          customer: [],
          ib: [],
          swap: [],
          wallet: [],
          total: []
        });
        Constants.EXCHANGES.map(v => {
          mappingData[v.value] = resData[v.value];
          mappingLaterData[v.value] = resData[v.value]?.reduce((acc, cur) => acc + cur.value, 0);
        });
        this.data = mappingData;
        this.laterData = mappingLaterData;
        this.profitWaiting = true;
      }
    });
  }

  private getParams(): DashboardDataRequest {
    const offset = this.getOffset();
    const tick = (this.timeInfo.tf === 'customize') ? 'day' : this.timeInfo.tf;
    const endTime = (this.timeInfo.tf === 'customize') ? this.timeInfo.to : getTimeDateBegin(new Date())
    let startTime = 0;
    switch (tick) {
      case 'day':
        startTime = endTime - (offset * 24 * 60 * 60 * 1000);
        break;
      case 'hour':
        startTime = endTime - (offset * 60 * 60 * 1000);
        break;
      case 'week':
        startTime = endTime - (offset * 7 * 24 * 60 * 60 * 1000);
        break;
    }
    return {
      tick: tick,
      start_time: startTime,
      end_time: endTime,
    }
  }


  getOffset(): any {
    switch (this.timeInfo.tf) {
      case 'hour':
        return 24;
      case 'day':
        return 7;
      case 'customize':
        const unit = 24 * 60 * 60 * 1000; //1D
        const range = this.timeInfo.to - this.timeInfo.from;
        return (range / unit);
      case 'week':
        return 4;
      default:
        return 10;
    }
  }

  onTimeframeChange(tf: any): void {
    this.timeInfo.tf = tf.timeframe;
    this.timeInfo.from = tf.from;
    this.timeInfo.to = tf.to;
    this.getProfitDashboardHistory();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
